import { Box, ListSubheader, styled } from '@mui/material';

const HeaderContainer = styled(Box, {
  name: 'view-header-container',
  slot: 'Root',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  // borderBottom: `1px solid ${theme.palette.primary.main}`,
}));

const StyledListHeader = styled(ListSubheader)({
  backgroundImage: 'var(--Paper-overlay)',
});

const DeliverablesContainer = styled(Box, {
  name: 'deliverables-container',
  slot: 'Root',
})({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  padding: '24px',
});

const DeliverablesTableContainer = styled(Box, {
  name: 'deliverables-table-container',
  slot: 'Root',
})({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  marginTop: '8px',
  overflow: 'hidden',
});

const DeliverableDetailsContainer = styled(Box, {
  name: 'deliverable-details-container',
  slot: 'Root',
})(() => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '4fr 1fr',
  gridTemplateRows: '0.1fr 0.1fr',
  gap: '16px',
}));

export {
  DeliverableDetailsContainer,
  DeliverablesContainer,
  DeliverablesTableContainer,
  HeaderContainer,
  StyledListHeader,
};
